import { SECTION_TABS, DEFAULT_SIDEBAR_LOGO_BACKGROUND } from '@/config/sidebar'
import { cn } from '@/lib/utils'
import type { SidebarSection } from '@/types/config'

const SIDEBAR_LOGO_SRC = '/images/logo.png'

interface SidebarLogoBannerProps {
	activeSection: SidebarSection | null
	onClick: () => void
}

export function SidebarLogoBanner({ activeSection, onClick }: SidebarLogoBannerProps) {
	const activeTab = activeSection ? SECTION_TABS.find((tab) => tab.key === activeSection) : null

	return (
		<button
			type='button'
			onClick={onClick}
			className={cn(
				'relative flex h-[92px] w-full shrink-0 cursor-pointer items-center justify-center border border-border transition-[background] duration-300 ease-in-out [clip-path:polygon(0%_0%,100%_0%,100%_85%,90%_85%,80%_100%,20%_100%,10%_85%,0%_85%)]',
				activeTab?.logoBackground ?? DEFAULT_SIDEBAR_LOGO_BACKGROUND,
			)}
		>
			<img src={SIDEBAR_LOGO_SRC} alt='Bets cycle' className='relative z-10 h-8 w-auto max-w-[85%] object-contain' />
		</button>
	)
}
